import $ from 'jquery';
import {is_array} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';


LP.dlgRespImport = {

    view: '',
    url: '',

    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.dlgRespImport.url = $(this).attr('url');
                LP.Dialog.open($.extend(params, {
                    name: 'respondentImport',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    sizeable: true,
                    width: 620,
                    height: 650,
                    submit: LP.dlgRespImport.onSubmit,
                    onLoad: LP.dlgRespImport.onLoad,
                    onClose: LP.dlgRespImport.onClose
                }));
            }
            return false;
        });
    },

    onLoad: function () {
        LP.dlgRespImport.view = 'upload';
        LP.dlgRespImport.setupView();
    },

    onClose: function () {
        window.Browser.send('backend/closeImportDialog/');

        /*if (LP.dlgRespImport.view == 'settings') {
         LP.dlgRespImport.view = 'upload';
         LP.dlgRespImport.setupView();
         $('.importErrors').hide();
         return true;
         }
         if (LP.dlgRespImport.view == 'profile') {
         LP.dlgRespImport.view = 'settings';
         LP.dlgRespImport.setupView();
         $('.importErrors').hide();
         return true;
         }*/
        return false;
    },

    onSubmit: function () {
        switch (LP.dlgRespImport.view) {
            case 'upload'  :
                return LP.dlgRespImport.submitUploadView();
            case 'settings':
                return LP.dlgRespImport.submitSettingsView();
            case 'profile' :
                return LP.dlgRespImport.submitProfileView();
            case 'status'  :
                return LP.dlgRespImport.submitStatusView();
        }
    },

    setupView: function () {
        $('.lp-import-panel').hide();

        var viewPanel = LP.dlgRespImport.getViewPanel();

        switch (LP.dlgRespImport.view) {
            case 'upload' :
                LP.dlgRespImport.initUploadView();
                break;
            case 'settings':
                LP.dlgRespImport.initSettingsView();
                break;
            case 'profile':
                LP.dlgRespImport.initProfileView();
                break;
            case 'status' :
                LP.dlgRespImport.initStatusView();
                break;
        }

        if (viewPanel) {
            $('#lp-dlg-button-upload .ui-button-text').html(viewPanel.attr('okText'));
            $('#lp-dlg-button-cancel .ui-button-text').html(viewPanel.attr('cancelText'));
            viewPanel.show();
        }
    },

    loadView: function (view) {
        var url = LP.dlgRespImport.url;
        var params = $('#importForm').serialize();
        params += '&view=' + view;

        LP.dlgRespImport.showLoader();

        window.Browser.send(url, params,
            function (json) {
                LP.dlgRespImport.hideLoader();
                LP.dlgRespImport.view = view;

                var viewPanel = LP.dlgRespImport.getViewPanel();
                viewPanel.html(json.html);
                LP.dlgRespImport.setupView();
            },
            function () {
                LP.dlgRespImport.hideLoader();
                LP.dlgRespImport.getViewPanel().show();
            }
        );
    },

    updatePreview: function () {
        var url = LP.dlgRespImport.url;
        var mode = '&mode=' + (LP.dlgRespImport.view == 'profile' ? 'profile' : 'preview');

        LP.dlgRespImport.showLoader(true);
        $('.importErrors').hide();

        window.Browser.send(url, $('#importForm').serialize() + '&importFile=' + $('#importFile').attr('file') + '&view=preview' + mode,
            function (json) {
                LP.dlgRespImport.hideLoader(true);
                $('.lp-import-preview-table', LP.dlgRespImport.getViewPanel()).html(json.html);
            },
            function (json) {
                $('.importErrors').html(json.errors.join('<br>')).show();
                LP.dlgRespImport.hideLoader(true);
            }
        );
    },

    showLoader: function (forPreview) {
        if (!forPreview) {
            $('.lp-import-panel').hide();
        }
        $('.lp-preview-loader').timedLoader(1);
    },

    hideLoader: function () {
        $('.lp-preview-loader').timedLoader(false);
    },

    getViewPanel: function () {
        switch (LP.dlgRespImport.view) {
            case 'upload'  :
                return $('#lp-import-upload');
            case 'settings':
                return $('#lp-import-settings');
            case 'profile' :
                return $('#lp-import-profile');
            case 'status'  :
                return $('#lp-import-status');
        }
        return 0;
    },

    // ------------- //
    // Upload View   //
    // ------------- //

    initUploadView: function () {
    },

    texts: {
        'de': 'Bitte wählen Sie eine Datei für den Import aus oder warten Sie bis der Upload abgeschlossen wurde.',
        'en': 'Please select a file for import or wait until the upload is completed.',
        'es': 'Por favor, seleccione un archivo para importar o espere hasta que la carga se haya completado.',
        'fr': 'Veuillez sélectionner un fichier pour l\'importation ou attendre que le téléchargement soit terminé.',
        'nl': 'Selecteer een bestand om te importeren of wacht tot het uploaden is voltooid.',
        'pt': 'Por favor seleccione um ficheiro para importação ou aguarde até que o carregamento esteja concluído.',
        'sv': 'Välj en fil för import eller vänta tills uppladdningen är klar.',
        'bg': 'Моля, изберете файл за импортиране или изчакайте, докато качването бъде завършено.'
    },

    submitUploadView: function () {
        if ($('#importFile').val().length == 0) {
            const msg = this.texts[LP.getLanguage()] || this.texts['en'];
            window.Toasts.errorToast(msg);
            return false;
        }

        var uploadURL = 'backend/uploadRespondentImport/';
        var uploadData = {poll: $('#pollId').val()};
        var uploadId = 'importFile';

        var onSuccess = function () {
            LP.dlgRespImport.loadView('settings');
        };

        var onError = function (json) {
            is_array(json.errors) && json.errors.forEach(function (err) {
                return window.Toasts.errorToast(err);
            });
        };

        window.Browser.upload(uploadURL, uploadData, uploadId).then(onSuccess).catch(onError);

        return false;
    },

    // ----------------- //
    // Settings View     //
    // ----------------- //

    initSettingsView: function () {
        $('#delimiterSelect').change(LP.dlgRespImport.updatePreview);
        $('#enclosureSelect').change(LP.dlgRespImport.updatePreview);

        $('input[name="useHeader"]').click(LP.dlgRespImport.updatePreview);
    },

    submitSettingsView: function () {
        LP.dlgRespImport.loadView('profile');
    },

    // ----------------- //
    // Profile View     //
    // ----------------- //

    initProfileView: function () {
        $('select[name="nameColumn"]').change(LP.dlgRespImport.updatePreview);
        $('select[name="emailColumn"]').change(LP.dlgRespImport.updatePreview);

        $('.importAttribute').click(LP.dlgRespImport.updatePreview);

        $('input[name="useAttributes"]').click(LP.dlgRespImport.updatePreview);

        $('select[name="profile"]').change(function () {
            if ($(this).val() != 'UD') {
                $('select[name="nameColumn"]').attr('disabled', '1');
                $('select[name="emailColumn"]').attr('disabled', '1');
            } else {
                $('select[name="nameColumn"]').removeAttr('disabled');
                $('select[name="emailColumn"]').removeAttr('disabled');
            }
            LP.dlgRespImport.updatePreview();
        });
    },

    testImportFile: function () {
        var url = 'backend/checkRespondentImport/';
        var params = $('#importForm').serialize();

        $('.importErrors').hide();

        LP.dlgRespImport.showLoader();
        window.Browser.send(url, params,
            function () {
                LP.dlgRespImport.hideLoader();

            },
            function (json) {
                $('.importErrors').html(json.errors.join('<br>')).show();
                LP.dlgRespImport.hideLoader();
                LP.dlgRespImport.getViewPanel().show();
                return true;
            }
        );
    },

    submitProfileView: function () {
        var url = 'backend/executeRespondentImport/';
        var params = $('#importForm').serialize();

        LP.dlgRespImport.showLoader();
        $('.importErrors').hide();

        window.Browser.send(url, params,
            function (json) {
                LP.dlgRespImport.hideLoader();
                LP.dlgRespImport.view = 'status';
                var viewPanel = LP.dlgRespImport.getViewPanel();
                viewPanel.html(json.html);
                LP.dlgRespImport.setupView();

                LP.respondentsList.reload();
            },
            function (json) {
                if (json.errors) {
                    $('.importErrors').html(json.errors.join('<br>')).show();
                }
                ;
                LP.dlgRespImport.hideLoader();
                LP.dlgRespImport.getViewPanel().show();
                return true;
            }
        );

        return false;
    },

    // ----------------- //
    // Status View       //
    // ----------------- //

    initStatusView: function () {
    },

    submitStatusView: function () {
        window.location.reload();
        LP.Dialog.close();
    }

};
